// @flow

import React, {ComponentType, useEffect} from 'react';

import {modelSubscriptionRegistry} from './subscriptionRegistry';

import type {
  ModelChangeMessageType,
  ModelSubscribedComponentPropsType,
} from './types';

export function registerModelWatcherEnhancer<P>(
  WrappedComponent: ComponentType<P & ModelSubscribedComponentPropsType>
) {
  return (props: P) => {
    const handler = React.useRef<
      null | ((message: ModelChangeMessageType) => unknown)
    >(null);

    useEffect(() => {
      if (handler.current == null) {
        throw new Error(
          `registerModelWatcherEnhancer: ${
            WrappedComponent.name ?? 'Unknown Component'
          } should call onModelChange prop on constructor`
        );
      }
      modelSubscriptionRegistry.register(handler.current);

      return () => {
        if (handler.current != null) {
          modelSubscriptionRegistry.unregister(handler.current);
        }
      };
    }, []);

    return (
      <WrappedComponent
        {...props}
        onModelChange={(handlerFunc) => {
          handler.current = handlerFunc;
        }}
      />
    );
  };
}
